import React from 'react';

import { Reveal } from '../Reveal/Reveal';
import { Skeleton } from '../Skeleton/Skeleton';
import { Root, SpentLabel, Spent, Budget } from './SpentOfBudget.styles';

export type SpentOfBudgetProps = {
  spent: number;
  budget: number;
  /** When true, prefix the figure with a translated "Spent" label. */
  withLabel?: boolean;
  /** While true, the figure shows a sheen placeholder (the endpoint is loading). */
  loading?: boolean;
};

/** "Spent $42/$50" budget-pacing figure (the spent amount bright, the budget dim).
 *  The optional "Spent" label is static chrome; only the figure loads in. */
export const SpentOfBudget = ({ spent, budget, withLabel = false, loading = false }: SpentOfBudgetProps): React.ReactElement => (
  <Root>
    {withLabel ? <SpentLabel text="Spent" tag="span" /> : null}
    <Reveal
      loading={loading}
      placeholder={
        <Spent>
          <Skeleton width="4.5ch" height="0.85em" radius={5} />
        </Spent>
      }
    >
      <Spent>${spent}</Spent>
      <Budget>/${budget}</Budget>
    </Reveal>
  </Root>
);

export default SpentOfBudget;
